document.addEventListener('DOMContentLoaded', function () {
	console.log('✅ search redirect loaded');

	// Ambil elemen input pencarian
	const searchInput = document.querySelector('input[type="search"]');
	if (!searchInput || !searchInput.form) return;

	const form = searchInput.form;

	// 🔸 Daftar kata → koleksi
	const collectionRedirects = {
'aksesoris': '/id/collections/aksesoris',
'atasan pria': '/id/collections/atasan-pria',
'atasan wanita': '/id/collections/atasan-wanita',
'baju': '/id/collections/baju',
'baju wanita': '/id/collections/baju-wanita',
'bawahan pria': '/id/collections/bawahan-pria',
'bawahan wanita': '/id/collections/bawahan-wanita',
'celana': '/id/collections/celana',
'celana cargo': '/id/collections/celana-cargo',
'celana cargo pria': '/id/collections/celana-cargo-pria',
'celana cargo wanita': '/id/collections/celana-cargo-wanita',
'celana jogger': '/id/collections/celana-jogger',
'celana jogger wanita': '/id/collections/celana-jogger-wanita',
'celana panjang': '/id/collections/celana-panjang',
'celana panjang pria': '/id/collections/celana-panjang-pria',
'celana panjang wanita': '/id/collections/celana-panjang-wanita',
'celana pendek': '/id/collections/celana-pendek',
'celana pendek pria': '/id/collections/celana-pendek-pria',
'celana pendek wanita': '/id/collections/celana-pendek-wanita',
'celana wanita': '/id/collections/celana-wanita',
'dompet': '/id/collections/dompet',
'hoodie pria': '/id/collections/hoodie-pria',
'hoodie wanita': '/id/collections/hoodie-wanita',
'hoodie': '/id/collections/hoodie',
'jaket': '/id/collections/jaket',
'jaket bomber': '/id/collections/jaket-bomber',
'jaket pria': '/id/collections/jaket-pria',
'jaket wanita': '/id/collections/jaket-wanita',
'kaos': '/id/collections/kaos',
'kaos pria': '/id/collections/kaos-pria',
'kaos wanita': '/id/collections/kaos-wanita',
'kaus kaki': '/id/collections/kaus-kaki',
'kemeja wanita': '/id/collections/kemeja-wanita',
'outer': '/id/collections/outer',
'outer pria': '/id/collections/outer-pria',
'outer wanita': '/id/collections/outer-wanita',
'pakaian': '/id/collections/pakaian',
'pria': '/id/collections/pria',
'rok wanita': '/id/collections/rok-wanita',
'rompi': '/id/collections/rompi',
'rompi wanita': '/id/collections/rompi-wanita',
'sweater': '/id/collections/sweater',
'sweater pria': '/id/collections/sweater-pria',
'sweater wanita': '/id/collections/sweater-wanita',
'tas': '/id/collections/tas',
'tas pria': '/id/collections/tas-pria',
'tas selempang': '/id/collections/tas-selempang',
'tas selempang pria': '/id/collections/tas-selempang-pria',
'tas selempang wanita': '/id/collections/tas-selempang-wanita',
'tas wanita': '/id/collections/tas-wanita',
'topi': '/id/collections/topi',
'topi rimba': '/id/collections/topi-rimba',
'wanita': '/id/collections/wanita'
	};

	form.addEventListener('submit', function (e) {
		const val = (searchInput.value || '').toLowerCase().trim();

		if (collectionRedirects[val]) {
			e.preventDefault();
			const target = collectionRedirects[val];

			// Tambah tracking parameter UTM / ref
			const redirectURL = `${target}`;

			window.location.href = redirectURL;
		}
	});
});
